/* =============================================================================
   DEAD RABBIT SOCIAL — THEME JS
   ============================================================================= */

(function () {
  'use strict';

  /* ── UTILITIES ── */
  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.from((context || document).querySelectorAll(selector)); }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }

  /* ── STICKY HEADER ── */
  var header = $('[data-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = y;
    }, { passive: true });
  }

  /* ── MOBILE NAV ── */
  var mobileToggle = $('[data-header] .site-header__menu-toggle');
  var mobileNav = $('#MobileNav');
  var mobileNavClose = $('[data-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  /* ── SEARCH OVERLAY ── */
  var searchToggle = $('[data-search-toggle]');
  var searchOverlay = $('#SearchOverlay');
  var searchClose = $('[data-search-close]');
  var searchInput = searchOverlay && searchOverlay.querySelector('.search-overlay__input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeMobileNav(); closeCart(); }
  });

  /* ── CART DRAWER ── */
  var cartDrawer = $('#CartDrawer');
  var cartToggles = $$('[data-cart-toggle]');
  var cartCloses = $$('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  cartToggles.forEach(function (btn) { btn.addEventListener('click', function () { refreshCartDrawer(); openCart(); }); });
  cartCloses.forEach(function (el) { el.addEventListener('click', closeCart); });

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderCartDrawer(cart) {
    // Update count badges
    $$('.site-header__cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!cartDrawer) return;
    var bodyEl = cartDrawer.querySelector('#CartDrawerItems');
    var panel = cartDrawer.querySelector('.cart-drawer__panel');
    var footerEl = panel && panel.querySelector('.cart-drawer__footer');
    if (!bodyEl) return;

    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is currently empty.</p><a href="/collections/all" class="btn btn--outline" data-cart-close>Continue Shopping</a></div>';
      if (footerEl) footerEl.remove();
      return;
    }

    bodyEl.innerHTML = cart.items.map(function (item) {
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return (
        '<div class="cart-drawer__item" data-item-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-media">' +
            '<img src="' + (item.image || '') + '" alt="" width="80" height="80" loading="lazy" class="cart-drawer__item-img">' +
          '</a>' +
          '<div class="cart-drawer__item-body">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantHtml +
            '<div class="cart-drawer__item-footer">' +
              '<div class="quantity-selector quantity-selector--sm">' +
                '<button type="button" class="quantity-selector__btn" data-cart-qty-minus="' + item.key + '">−</button>' +
                '<span class="quantity-selector__display">' + item.quantity + '</span>' +
                '<button type="button" class="quantity-selector__btn" data-cart-qty-plus="' + item.key + '">+</button>' +
              '</div>' +
              '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="cart-drawer__item-remove" data-cart-remove="' + item.key + '" aria-label="Remove">✕</button>' +
        '</div>'
      );
    }).join('');

    if (footerEl) {
      var subtotalEl = footerEl.querySelector('.cart-drawer__subtotal-price');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      // Fix empty checkout URL (routes.checkout_url can render blank on some stores)
      var checkoutLink = footerEl.querySelector('a.btn--primary');
      if (checkoutLink && !checkoutLink.getAttribute('href')) {
        checkoutLink.setAttribute('href', '/checkout');
      }
    } else if (panel) {
      panel.insertAdjacentHTML('beforeend',
        '<div class="cart-drawer__footer">' +
          '<div class="cart-drawer__subtotal">' +
            '<span>Subtotal</span>' +
            '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<p class="cart-drawer__shipping-note">Shipping and taxes calculated at checkout.</p>' +
          '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>' +
          '<a href="/cart" class="cart-drawer__view-cart btn btn--ghost">View Cart</a>' +
        '</div>'
      );
    }
  }

  function refreshCartDrawer() {
    fetchJSON('/cart.js').then(renderCartDrawer);
  }

  /* ── CART AJAX — add to cart forms ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.dataset.type || form.dataset.type !== 'add-to-cart-form') return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-to-cart]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    var data = {};
    new FormData(form).forEach(function (v, k) { data[k] = v; });

    fetchJSON(form.action || '/cart/add.js', { method: 'POST', body: JSON.stringify(data) })
      .then(function () {
        refreshCartDrawer();
        openCart();
        if (btn) { btn.textContent = 'Added!'; }
        setTimeout(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        }, 1500);
      })
      .catch(function (err) {
        console.error('Add to cart error', err);
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
  });

  /* Quick-add forms (product cards) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('product-card__quick-add')) return;
    e.preventDefault();

    var data = { id: form.querySelector('input[name="id"]').value, quantity: 1 };
    fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify(data) })
      .then(function () { refreshCartDrawer(); openCart(); })
      .catch(function (err) { console.error(err); });
  });

  /* ── CART DRAWER quantity controls ── */
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var target = e.target;

      if ('cartQtyMinus' in target.dataset || 'cartQtyPlus' in target.dataset) {
        var key = target.dataset.cartQtyMinus || target.dataset.cartQtyPlus;
        if (!key) { var row = target.closest('[data-item-key]'); key = row && row.dataset.itemKey; }
        if (!key) return;
        var display = target.parentElement.querySelector('.quantity-selector__display');
        var current = parseInt(display.textContent, 10);
        var newQty = ('cartQtyMinus' in target.dataset) ? Math.max(0, current - 1) : current + 1;

        fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: newQty }) })
          .then(function (cart) { renderCartDrawer(cart); });
      }

      if ('cartRemove' in target.dataset) {
        var key = target.dataset.cartRemove;
        if (!key) { var row = target.closest('[data-item-key]'); key = row && row.dataset.itemKey; }
        if (!key) return;
        fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function (cart) { renderCartDrawer(cart); });
      }
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── PRODUCT PAGE ── */
  var productPage = $('.product-page');
  if (productPage) {
    var productJSON = document.getElementById('ProductJSON-' + (productPage.dataset.sectionId || ''));
    var product;
    try { product = JSON.parse(productJSON && productJSON.textContent); } catch (e) {}

    // Build filename → media ID map so variant image switching works
    // (variant.featured_image.id is an image ID; media.id is a different media ID;
    //  but both share the same CDN filename, so we match on that)
    var srcToMediaId = {};
    if (product && product.media) {
      product.media.forEach(function (m) {
        if (m.src) {
          var filename = m.src.split('?')[0].split('/').pop();
          srcToMediaId[filename] = m.id;
        }
      });
    }

    // Variant selection
    var optionInputs = $$('[data-option-value]', productPage);
    var hiddenVariantInput = $('[data-productid]', productPage);
    var priceContainer = productPage.querySelector('.product-info__price');
    var addToCartBtn = productPage.querySelector('[data-add-to-cart]');

    function getSelectedOptions() {
      var opts = {};
      $$('.product-option', productPage).forEach(function (optionEl) {
        var name = optionEl.dataset.optionName;
        var checked = optionEl.querySelector('input:checked');
        if (checked) opts[name] = checked.value;
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return product.options.every(function (opt, i) {
          return v['option' + (i + 1)] === selectedOpts[opt.toLowerCase()];
        });
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        // Update selected styling
        var parent = this.closest('.product-option');
        $$('.product-option__value', parent).forEach(function (lbl) { lbl.classList.remove('is-selected'); });
        this.closest('.product-option__value').classList.add('is-selected');

        var selected = getSelectedOptions();
        var variant = findVariant(selected);

        if (variant) {
          if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
          // Update price
          if (priceContainer) {
            var price = variant.price;
            var compare = variant.compare_at_price;
            var html = '';
            if (compare && compare > price) {
              html = '<div class="price price--on-sale"><span class="price__regular price__regular--strikethrough">' + formatMoney(compare) + '</span><span class="price__sale">' + formatMoney(price) + '</span></div>';
            } else {
              html = '<div class="price"><span class="price__regular">' + formatMoney(price) + '</span></div>';
            }
            priceContainer.innerHTML = html;
          }
          // Update button
          if (addToCartBtn) {
            if (variant.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.classList.remove('btn--disabled');
              addToCartBtn.textContent = 'Add to Cart';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('btn--disabled');
              addToCartBtn.textContent = 'Sold Out';
            }
          }
          // Update media if variant has image
          if (variant.featured_image) {
            var fiSrc = variant.featured_image.src || '';
            var fiFilename = fiSrc.split('?')[0].split('/').pop();
            var targetMediaId = srcToMediaId[fiFilename] || variant.featured_image.id;
            switchMedia(targetMediaId);
          }
        }
      });
    });

    // Media gallery
    function switchMedia(mediaId) {
      $$('.product-media__item', productPage).forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.mediaId == mediaId);
      });
      $$('.product-media__thumb', productPage).forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.mediaId == mediaId);
      });
    }

    $$('.product-media__thumb', productPage).forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchMedia(this.dataset.mediaId);
      });
    });
  }

  /* ── QUANTITY SELECTORS (cart page / product page) ── */
  document.addEventListener('click', function (e) {
    if (e.target.dataset.qtyMinus) {
      var input = e.target.parentElement.querySelector('[data-qty-input]');
      if (input) input.value = Math.max(1, parseInt(input.value, 10) - 1);
    }
    if (e.target.dataset.qtyPlus) {
      var input = e.target.parentElement.querySelector('[data-qty-input]');
      if (input) input.value = parseInt(input.value, 10) + 1;
    }
  });

  /* ── SORT BY (collection page) ── */
  var sortSelect = $('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── INIT ── */
  refreshCartDrawer();

})();
